var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActionMapIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.649,
    height: 37.135,
    viewBox: "0 0 40.649 37.135",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "map",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_999",
    "data-name": "Tracciato 999",
    d: "M1,9.027V37.135l12.3-7.027,14.054,7.027,12.3-7.027V2l-12.3,7.027L13.3,2Z",
    transform: "translate(-1 -2)",
    fill: "none",
    stroke: "#272829",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linea_222",
    "data-name": "Linea 222",
    y2: 28.078,
    transform: "translate(12.284 0)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linea_223",
    "data-name": "Linea 223",
    y2: 28.078,
    transform: "translate(26.323 7.02)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(14.629 10.768)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Apert-filiale",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_149",
    "data-name": "Tracciato 149",
    d: "M15.508,5a4.7,4.7,0,0,0-3.219,8.12l3.219,3.207s3.016-2.952,3.3-3.283A4.7,4.7,0,0,0,15.508,5Zm0,6.809a2.1,2.1,0,1,0,0-.009Z",
    transform: "translate(-10.814 -5)",
    fill: "none",
    stroke: "#e02027",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linea_149",
    "data-name": "Linea 149",
    x2: 4.222,
    transform: "translate(2.583 13.041)",
    fill: "none",
    stroke: "#e02027",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionMapIcon);
export default __webpack_public_path__ + "static/media/action-map-icon.2211734f9e7b9f4cd6428350248a6f78.svg";
export { ForwardRef as ReactComponent };